module.exports = __webpack_public_path__ + "img/slide-4.d86a1576.jpg";